//请求类的响应i18n
import { res as ch, transferDialog as transferDialog_ch } from "./../zh";
import { res as tw, transferDialog as transferDialog_tw } from "./../tw";
import { res as en, transferDialog as transferDialog_en } from "./../en";
import { res as kr, transferDialog as transferDialog_kr } from "./../kr";
import { res as pt, transferDialog as transferDialog_pt } from "./../pt_BR";
import { res as ja_JP, transferDialog as transferDialog_ja } from "./../ja_JP";
import { res as vi_VN, transferDialog as transferDialog_vi } from "./../vi";
import { res as id_ID, transferDialog as transferDialog_id } from "./../ba";
import { res as tr_TR, transferDialog as transferDialog_tr } from "./../vi";
import { res as ru_Ru, transferDialog as transferDialog_ru } from "./../ru";
import { res as fr_FR, transferDialog as transferDialog_fr } from "./../fr";

export {
  ch,
  transferDialog_ch,
  tw,
  transferDialog_tw,
  en,
  transferDialog_en,
  kr,
  transferDialog_kr,
  pt,
  transferDialog_pt,
  ja_JP,
  transferDialog_ja,
  vi_VN,
  transferDialog_vi,
  id_ID,
  transferDialog_id,
  tr_TR,
  transferDialog_tr,
  ru_Ru,
  transferDialog_ru,
  fr_FR,
  transferDialog_fr
};



// WEBPACK FOOTER //
// ./src/i18n/lang/res/index.js